/**
 * Utility functions for text processing and cleaning
 */

/**
 * Remove citation references like [1], [2][3], etc. from text
 */
export function removeCitations(text: string): string {
  // Remove citation patterns like [1], [2][3], [1,2,3], etc.
  return text.replace(/\[\d+(?:,\s*\d+)*\]|\[\d+\]\[\d+\]*/g, '').trim();
}

/**
 * Clean up text by removing extra whitespace and citations
 */
export function cleanText(text: string): string {
  // Remove citations
  let cleaned = removeCitations(text);
  
  // Remove multiple spaces
  cleaned = cleaned.replace(/\s+/g, ' ');
  
  // Remove trailing/leading whitespace
  cleaned = cleaned.trim();
  
  return cleaned;
}

/**
 * Truncate text to a maximum length with ellipsis
 */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  
  // Try to break at a word boundary
  const truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  
  if (lastSpace > maxLength * 0.8) {
    return truncated.substring(0, lastSpace) + '...';
  }
  
  return truncated + '...';
}